import { render, staticRenderFns } from "./ResourceCategoryCreate.vue?vue&type=template&id=f8a05824&"
import script from "./ResourceCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./ResourceCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports